import { render, staticRenderFns } from "./Penalty.vue?vue&type=template&id=768a078d&scoped=true&"
import script from "./Penalty.vue?vue&type=script&lang=js&"
export * from "./Penalty.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "768a078d",
  null
  
)

export default component.exports